import { createFileRoute, getRouteApi } from '@tanstack/react-router'

import { LearnpathsSummaryDetailsTabPanel } from '@/learnpaths-summary/components/LearnpathsSummaryDetailsTabPanel/LearnpathsSummaryDetailsTabPanel'
import { LearnpathsSummaryDetailsTabsReports } from '@/learnpaths-summary/components/LearnpathsSummaryDetailsTabsReports/LearnpathsSummaryDetailsTabsReports'
import { useManagedLearnpath } from '@/learnpaths/queries/useManagedLearnpath'

const { useParams, useSearch } = getRouteApi(
  '/company/_management/learnpaths/overview/$learnpathId',
)

export const Route = createFileRoute(
  '/company/_management/learnpaths/overview/$learnpathId/reports',
)({
  component: ReportsTab,
})

function ReportsTab() {
  const { learnpathId } = useParams()
  const { only_direct_learners_stats = true } = useSearch()
  const { data } = useManagedLearnpath({
    learnpathId,
    only_direct_learners_stats,
  })

  return (
    <LearnpathsSummaryDetailsTabPanel>
      <LearnpathsSummaryDetailsTabsReports
        isLPrecurring={!!data?.recurring_draft_id}
      />
    </LearnpathsSummaryDetailsTabPanel>
  )
}
